/** ****************** Private ****************** */

export const moduleName = 'Utils';
// logging output to console
export const debug = import.meta.env.DEV;
export const verbose = false;
